import React from "react";
import dayjs from "dayjs";
import { DateRangePicker } from "../../../../shared/DateRangePicker";

interface Props {
  value: string;
  onChange: (value: string) => void;
  label: string;
  error?: string;
  removeErrorMessage: () => void;
}

// Needed this, because the first logic was to choose MMMM/YYYY for education
// now some of the data on backend is saved as ISO with month and year
const toYear = (s: string) => {
  if (!s) return "";
  if (/^\d{4}$/.test(s)) return s; // already "YYYY"
  const d = dayjs(s);
  return d.isValid() ? String(d.year()) : "";
};

export const EducationDateRangePicker: React.FC<Props> = ({
  value,
  onChange,
  label,
  error,
  removeErrorMessage,
}) => {
  const period: [string, string] = value?.split(" - ") as [string, string];
  const years: [string, string] = [toYear(period[0]), toYear(period[1])];

  const selectedStartDate = years[0] ? dayjs(years[0]) : null;
  const minDateEnd = selectedStartDate?.isValid()
    ? selectedStartDate
    : undefined;

  const handleChange = (newRange: [string, string]) => {
    const onlyYears: [string, string] = [
      toYear(newRange[0]),
      toYear(newRange[1]),
    ];
    onChange(onlyYears.join(" - "));
    removeErrorMessage();
  };

  return (
    <DateRangePicker
      label={label}
      value={years}
      onChange={handleChange}
      minDateEnd={minDateEnd}
      error={error}
      isEducation
    />
  );
};
